export default "__VITE_ASSET__BSB9MiUs__"